export default __webpack_public_path__ + "static/media/raki_detail6.0f88830c.jpg";